import * as React from 'react'
import type { SVGProps } from 'react'
function SvgNiederschlag(props: SVGProps<SVGSVGElement>) {
  return (
    <svg viewBox="0 0 132.6 136" xmlns="http://www.w3.org/2000/svg" {...props}>
      <g>
        <path d="M24.5,70.7h.7c13.9,0,25.2-11.3,25.2-25.1C50.8,30,29.3,3.7,26.8.8c-.8-1.1-2.5-1-3.2,0C21.1,3.8-.4,30.1,0,45.5c0,13.7,10.9,24.8,24.5,25.2ZM24,6.6l1.2-1.5,1.2,1.5c4.8,6.1,20.3,27.1,20,39,0,11.6-9.5,21.1-21.2,21.1S4,57.2,4,45.4c-.3-11.8,15.2-32.7,20-38.8Z" />
        <path d="M109.6,43.5c-2.1,2.5-20.2,24.8-19.8,37.8,0,11.8,9.6,21.4,21.4,21.4h.4c11.7-.2,21.1-9.7,21.1-21.3.4-13.2-17.8-35.4-19.8-37.9-.4-.5-1-.8-1.6-.8s-1.2.3-1.6.8ZM112.4,49.4c3.9,5,16.5,22.3,16.3,31.9,0,9.6-7.8,17.4-17.4,17.4-9.6,0-17.4-7.8-17.4-17.5-.3-9.7,12.4-26.8,16.3-31.9l1.2-1.5,1.2,1.5Z" />
        <path d="M54.6,85.5c-1.8,2.2-17.1,21-16.8,32.1,0,10,8,18.1,17.8,18.4h.6c10.1,0,18.4-8.3,18.4-18.4.3-11.2-15.1-30-16.8-32.2-.4-.5-1-.8-1.6-.8s-1.2.3-1.6.8ZM70.6,117.5h0c0,8-6.5,14.5-14.4,14.5s-14.4-6.5-14.4-14.4h0c-.2-8.1,11-23.2,13.2-26.2l1.2-1.6,1.2,1.6c2.3,2.9,13.5,18.1,13.2,26.1Z" />
      </g>
    </svg>
  )
}
export default SvgNiederschlag
